// Sticky Footer taken from CSS-Tricks
$(window).on('load', function() { 
  var footerHeight = 0,
      $footer = $('#footer'),
      absolutelyPositioned,
      windowHeight,
      documentHeight;
      
  positionFooter();
       
  function positionFooter() {
    setTimeout( function() {
      footerHeight = Math.floor($footer.outerHeight());
      windowHeight = Math.floor($(window).height());
      documentHeight = Math.floor($(document.body).height());
         
      if((documentHeight < windowHeight && !absolutelyPositioned) ||
        ((documentHeight + footerHeight) < windowHeight && absolutelyPositioned)) {
        absolutelyPositioned = true;
        $footer.css({
          position: 'absolute',
          bottom: 0,
          left: 0,
          right: 0,
          visibility: 'visible'
        });

      } else {
        absolutelyPositioned = false;
        $footer.css({
          position: 'static',
          visibility: 'visible'
        });
      }

      $(window).trigger('footerPositioned');
    }, 200);
  }
  
  $(window).scroll(positionFooter).resize(positionFooter);
  $(document).on('navbar.content.moving navbar.content.moved', positionFooter);
});